function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("path", {
  d: "m261.76 432.31a24.74 24.74 0 1 1 12.24-32.79 24.73 24.73 0 0 1-12.24 32.79z",
  fill: "#263238"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "g"
}, /*#__PURE__*/React.createElement("path", {
  d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("path", {
  d: "m282.21 125.93s-4.47 0.47-5.88 1.68-12.14 10.39-13.88 15.83 4.87 21.72 12.09 28 16.24 12.93 23.9 11.56 16.46-13.17 17.37-16.38-29.06-40-29.06-40-2.13-2.14-4.54-0.69z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "e"
}, /*#__PURE__*/React.createElement("path", {
  d: "m320.39 104.12s-4.74-1.6-11.8 1.4-24.72 13.37-27.31 22.4c-1.71 5.93 17 33.62 28.69 38.18 3.14 1.22 6 2.55 12.43-2.69s19.91-19.79 23.44-26.2-2-11.19-3.85-14-16.64-21.21-21.6-19.09z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-15.38 99.53) rotate(-16.2)",
  cx: 341.93,
  cy: 103.81,
  r: 26.5,
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "m257.06 138.09s4.16 12 9.51 12.89 12.79-8.19 14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07 20-23.07 20-8.61-7.57-13.18-3.66 1.39 15.87 5.6 20.8 11.89 12.16 19.26 10.44 13.21-15.55 18-19.62 8-2.32 9.06-1.09z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m281.13 180.59s12.17 3.58 16-0.24 4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66 8.93-20.83 19.49 2.9 30.42 2.9 30.42-11.15 2.61-10.63 8.61 13.73 8.09 20.18 7.52 16.74-2.63 19.61-9.62-5-19.78-5.54-26 2.82-7.93 4.43-8.07z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.88,272.43s-.48,70.8,56.64,119.44,138.69,54.06,204.65,60.2S438.39,422,448.25,365.48s-40-74.42-64.93-139.64-21.63-86.38-78.1-127.52S157,79.26,106.81,146.07,58.88,272.43,58.88,272.43Z",
  fill: "#91C788"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M58.88,272.43s-.48,70.8,56.64,119.44,138.69,54.06,204.65,60.2S438.39,422,448.25,365.48s-40-74.42-64.93-139.64-21.63-86.38-78.1-127.52S157,79.26,106.81,146.07,58.88,272.43,58.88,272.43Z",
  fill: "#fff",
  opacity: 0.7
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m396.65 263.73a15.34 15.34 0 1 1 20.65-6.64 15.33 15.33 0 0 1-20.65 6.64z",
  fill: "#263238"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M411.38,241.85l7.44,10.44a15.17,15.17,0,0,0-.34-6.08Z",
  fill: "#91C788"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m395.78 236.94 17.68 24.94a15.17 15.17 0 0 0 3.61-4.38l-14.83-22.68a15.32 15.32 0 0 0-6.46 2.12z",
  fill: "#91C788"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m403.09 265.4-7.68-11 4 10.42a15.58 15.58 0 0 0 3.68 0.58z",
  fill: "#91C788"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M409.33,264.32l-17.56-23.93c-.17.21-.33.44-.49.66L404,265.42A15.47,15.47,0,0,0,409.33,264.32Z",
  fill: "#91C788"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m261.76 432.31a24.74 24.74 0 1 1 12.24-32.79 24.73 24.73 0 0 1-12.24 32.79z",
  fill: "#263238"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#h)",
  fill: "#91C788"
}, /*#__PURE__*/React.createElement("path", {
  d: "M273.78,420.5,256.9,394l19.17,18.42c.05-.51.09-1,.11-1.54l-22.71-25.74a24.2,24.2,0,0,0-5.82.22l4.56,7.25-7.54-6.6h0l6,10.86-12.13-8.14c-.3.19-.6.38-.89.58l22.51,25-17.86-13.59,6.35,10-9.25-6.4,24.22,27.06a24.58,24.58,0,0,0,7.57-6.57l-4.93-8.23,6.12,6.52A23.74,23.74,0,0,0,273.78,420.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m258.77 433.45-19.35-22.32 8.6 13.28-21.2-16.62a24.73 24.73 0 0 0 21.42 26.55l-7.64-6.79 11.86 7a25.24 25.24 0 0 0 6.31-1.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m260.69 386.87 10.85 12.6-2.2-4.81 3.51 2.7a24.63 24.63 0 0 0-12.16-10.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m235.46 406.36-5.86-8.1a25.21 25.21 0 0 0-2.5 7.31z"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m288.23 393.36c-1.8-3.94-9.78-4.49-20.38-2.08a22.7 22.7 0 0 1 1.91 1.89c7.92-1.82 13.57-1.66 14.74 0.88 2.06 4.51-10.79 14.81-28.71 23s-34.1 11.19-36.17 6.68c-1.06-2.32 1.85-6.18 7.36-10.5a23.69 23.69 0 0 1-0.23-2.65c-7.69 6-11.78 11.84-10.09 15.52 2.85 6.24 21.19 4 41-5.07s33.42-21.43 30.57-27.67z",
  fill: "#263238"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 133.94,
  cy: 174.23,
  r: 24.43,
  fill: "#91C788"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m139.7 156.16a18.88 18.88 0 0 1 5.59-3.55 23.93 23.93 0 0 0-6.3-2.27 56.64 56.64 0 0 0-6.44 5c-8.74 7.94-6.36 7.15-19.06 11.91a19.87 19.87 0 0 0-3.37 1.62 24.06 24.06 0 0 0-0.61 5.33 24.38 24.38 0 0 0 1.73 9c4.54-1.38 10.58-3.62 13.37-6.41 4.76-4.74 5.56-11.89 15.09-20.63z",
  fill: "#263238"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m116.19 191a24.61 24.61 0 0 0 6.39 4.87c4.55-3.18 6.67-6.56 13.15-9.5 5.69-2.59 15.08-3.16 20.94-3.23a24.32 24.32 0 0 0 1.69-8.89c0-0.42 0-0.83-0.06-1.25a70.36 70.36 0 0 0-20.19 4.63c-9.24 3.67-13.72 10.22-21.92 13.37z",
  fill: "#263238"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m140.49 165.69c4.32 2.16 11 1 16.15-0.44a24.52 24.52 0 0 0-4.11-6.83c-6.88 1.29-18.02 4.28-12.04 7.27z",
  fill: "#263238"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m325.24 82.79h0a3.48 3.48 0 0 1 1.09-4.79l5.67-3.59a3.48 3.48 0 0 1 4.81 1.09h0a3.48 3.48 0 0 1-1.09 4.81l-5.66 3.57a3.49 3.49 0 0 1-4.82-1.09z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m301.26 122.48s16-4.15 20.9-15.19c0 0-0.32-0.47-0.89-1.22l-4.16-3.47a139.3 139.3 0 0 0-17.57 2.61c-8.78 2-15.61-2.28-18.21-12s-5-24.11-5-24.11c-1.36 16.24-1.31 15.17-1.71 21.65-0.28 4.56 2.71 15.16 7 19.57s19.64 12.16 19.64 12.16z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301.26 122.48s16-4.15 20.9-15.19c0 0-0.32-0.47-0.89-1.22l-4.16-3.47a139.3 139.3 0 0 0-17.57 2.61c-8.78 2-15.61-2.28-18.21-12s-5-24.11-5-24.11c-1.36 16.24-1.31 15.17-1.71 21.65-0.28 4.56 2.71 15.16 7 19.57s19.64 12.16 19.64 12.16z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M295.5,82.42l-2-11a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-.6,7.18-.93,11-1.14,13.54Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M279.54,107.54a18.33,18.33,0,0,0,1.21,1.74c4.22-3.53,13.72-12,18-19.27-1.2-.38-2-.6-2-.6S287.91,101,279.54,107.54Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M296.56,55.55s-9.45-.35-10.45,7.62",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  x1: 289.29,
  x2: 289.61,
  y1: 41.63,
  y2: 51.68,
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  x1: 282.67,
  x2: 283.32,
  y1: 42.22,
  y2: 51.31,
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  x1: 276.98,
  x2: 278,
  y1: 48.82,
  y2: 54.49,
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m291.51 51.21s-10.67 1.79-14.78 5.28",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "m289 114.24c3.48-3 3.21-9-0.62-13.49-3.69-4.32-9.34-5.59-12.86-3 1.19 4.6 3.37 9.76 6.07 12.51a39.12 39.12 0 0 0 6.41 4.74 6 6 0 0 0 1-0.76z",
  fill: "#91C788"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m289 114.24c3.48-3 3.21-9-0.62-13.49-3.69-4.32-9.34-5.59-12.86-3 1.19 4.6 3.37 9.76 6.07 12.51a39.12 39.12 0 0 0 6.41 4.74 6 6 0 0 0 1-0.76z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m282.21 125.93s-4.47 0.47-5.88 1.68-12.14 10.39-13.88 15.83 4.87 21.72 12.09 28 16.24 12.93 23.9 11.56 16.46-13.17 17.37-16.38-29.06-40-29.06-40-2.13-2.14-4.54-0.69z",
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m282.21 125.93s-0.88 0.09-2 0.3l1 1.69s-0.92 9.48 5.58 20.22 17.89 17.56 17.56 21.46 1 9.11-8.78 8.46-20.16-17.24-23.74-25.37c-1.86-4.23-3.46-10.65-5.29-15.62a20.91 20.91 0 0 0-4.16 6.37c-1.74 5.44 4.87 21.72 12.09 28s16.24 12.93 23.9 11.56 16.46-13.17 17.37-16.38-29.06-40-29.06-40-2.06-2.14-4.47-0.69z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "m282.21 125.93s-0.88 0.09-2 0.3l1 1.69s-0.92 9.48 5.58 20.22 17.89 17.56 17.56 21.46 1 9.11-8.78 8.46-20.16-17.24-23.74-25.37c-1.86-4.23-3.46-10.65-5.29-15.62a20.91 20.91 0 0 0-4.16 6.37c-1.74 5.44 4.87 21.72 12.09 28s16.24 12.93 23.9 11.56 16.46-13.17 17.37-16.38-29.06-40-29.06-40-2.06-2.14-4.47-0.69z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m282.21 125.93s-4.47 0.47-5.88 1.68-12.14 10.39-13.88 15.83 4.87 21.72 12.09 28 16.24 12.93 23.9 11.56 16.46-13.17 17.37-16.38-29.06-40-29.06-40-2.13-2.14-4.54-0.69z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m320.39 104.12s-4.74-1.6-11.8 1.4-24.72 13.37-27.31 22.4c-1.71 5.93 17 33.62 28.69 38.18 3.14 1.22 6 2.55 12.43-2.69s19.91-19.79 23.44-26.2-2-11.19-3.85-14-16.64-21.21-21.6-19.09z",
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m345.88 137.12-12.19 3.88s-12.68 15-17.23 18.87-18.87-5.53-23.75-10.09l-1.44-1.34c5.83 7.92 13.08 15.48 18.7 17.68 3.14 1.22 6 2.55 12.43-2.69s19.91-19.79 23.44-26.2a0.36 0.36 0 0 0 0.04-0.11z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.55,135.78l6.56.85c2.91-6.12-2.29-10.7-4.12-13.44s-16.64-21.19-21.6-19.07a11.06,11.06,0,0,0-2.79-.41c-6,4.52-5.32,9.71.16,19.06S339.55,135.78,339.55,135.78Z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m345.88 137.12-12.19 3.88s-12.68 15-17.23 18.87-18.87-5.53-23.75-10.09l-1.44-1.34c5.83 7.92 13.08 15.48 18.7 17.68 3.14 1.22 6 2.55 12.43-2.69s19.91-19.79 23.44-26.2a0.36 0.36 0 0 0 0.04-0.11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M339.55,135.78l6.56.85c2.91-6.12-2.29-10.7-4.12-13.44s-16.64-21.19-21.6-19.07a11.06,11.06,0,0,0-2.79-.41c-6,4.52-5.32,9.71.16,19.06S339.55,135.78,339.55,135.78Z"
})));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m320.39 104.12s-4.74-1.6-11.8 1.4-24.72 13.37-27.31 22.4c-1.71 5.93 17 33.62 28.69 38.18 3.14 1.22 6 2.55 12.43-2.69s19.91-19.79 23.44-26.2-2-11.19-3.85-14-16.64-21.21-21.6-19.09z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  transform: "translate(232.93 -195.3) rotate(53.91)",
  x: 292.3,
  y: 117.55,
  width: 32.36,
  height: 27.62,
  rx: 5.89,
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M479.52,230.22c-14.95-39-52.35-38.57-85.34-38.16-11.37.14-22.11.28-32-1-33.37-4.22-42.91-38.52-43-39a2.38,2.38,0,0,0-4.61,1.22c.1.38,10.39,37.84,47,42.48,10.23,1.3,21.64,1.15,32.68,1,33-.41,67.06-.84,80.83,35.09a49.43,49.43,0,0,1-8.95,49.48c-10.24,11.79-24.77,16.57-39.85,13.11-14.23-3.27-28.29-7.77-41.89-12.12-22.51-7.2-45.78-14.65-70.48-16.72-42.35-3.56-71.81,17.07-105.89,40.94-6.86,4.81-13.95,9.77-21.38,14.71l-4.23,2.82c-21.09,14.08-42.89,28.64-67.56,31.27-19.18,2-38.68-6.94-48.55-22.35A37.74,37.74,0,0,1,61,304.31,31.75,31.75,0,0,1,76.05,284c12.77-7.61,35.33-10.14,54.57-8l.33-4.75c-20.19-2.15-43.75.61-57.34,8.7a36.91,36.91,0,0,0-17.25,23.35,42.49,42.49,0,0,0,5.92,32.42c9.9,15.47,27.81,24.82,46.82,24.85a59.76,59.76,0,0,0,6.25-.33c25.83-2.75,49.14-18.31,69.69-32l4.22-2.82c7.49-5,14.6-10,21.48-14.77,33.33-23.35,62.11-43.52,102.76-40.1,24.16,2,47.17,9.39,69.42,16.51,13.7,4.38,27.86,8.91,42.28,12.22,16.86,3.87,33.08-1.46,44.52-14.62A54.23,54.23,0,0,0,479.52,230.22Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m313.4 121.06a3.25 3.25 0 1 1-3.25-3.25 3.25 3.25 0 0 1 3.25 3.25z",
  fill: "#91C788",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "m304.58 128.48a3.25 3.25 0 1 1-3.24-3.24 3.24 3.24 0 0 1 3.24 3.24z",
  fill: "#91C788",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-15.38 99.53) rotate(-16.2)",
  cx: 341.93,
  cy: 103.81,
  r: 26.5,
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M362.07,86.59a27,27,0,0,0-3-3A26.47,26.47,0,0,1,316.45,111a26.49,26.49,0,1,0,45.62-24.41Z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "M362.07,86.59a27,27,0,0,0-3-3A26.47,26.47,0,0,1,316.45,111a26.49,26.49,0,1,0,45.62-24.41Z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-15.38 99.53) rotate(-16.2)",
  cx: 341.93,
  cy: 103.81,
  r: 26.5,
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  x1: 365.46,
  x2: 373.18,
  y1: 122.13,
  y2: 115.53,
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m375.23 116.36a2 2 0 0 0-2.65-3.1 2 2 0 1 0 2.65 3.1z",
  fill: "#263238"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M356,130.13h0a3.48,3.48,0,0,1,.39-4.91l5.08-4.36a3.5,3.5,0,0,1,4.92.39h0a3.48,3.48,0,0,1-.38,4.91l-5.09,4.36A3.49,3.49,0,0,1,356,130.13Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m357.19 149.85c-1-5.83-5.64-14.07-9.48-15.35l-0.24-0.06a56.31 56.31 0 0 1 4.11 26.71c-1.3 16.58-16.51 29.66-21.14 34.47-3.71 3.86-8.38 9.27-15.11 13.27a3.25 3.25 0 0 0 1.71 3 8.13 8.13 0 0 0 4.59 0s1.81 2.12 3.64 1.77 6-5.45 9.3-9.79 16-19.77 21-29.23 2.64-18.96 1.62-24.79z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "m357.19 149.85c-1-5.83-5.64-14.07-9.48-15.35l-0.24-0.06a56.31 56.31 0 0 1 4.11 26.71c-1.3 16.58-16.51 29.66-21.14 34.47-3.71 3.86-8.38 9.27-15.11 13.27a3.25 3.25 0 0 0 1.71 3 8.13 8.13 0 0 0 4.59 0s1.81 2.12 3.64 1.77 6-5.45 9.3-9.79 16-19.77 21-29.23 2.64-18.96 1.62-24.79z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "m325.27 213.7c1.83-0.35 6-5.45 9.3-9.79 1.87-2.45 6.75-8.46 11.54-14.93-3.21-11-12.71-14.29-16.94-15.2-1.91 2.86-3.87 5.6-4.71 6.19-1.91 1.33-7.29 0.75-12.59 3.45s-3.55 5.47-2.14 6.4 5.73-1.85 7-1.75 1.13 2.39-3.87 7.58-7.29 5.35-5.86 7.75a3.69 3.69 0 0 0 4 1.79 2.57 2.57 0 0 0 1.4 3.07c2.06 1 2.94 0.23 2.94 0.23s-0.2 2.61 1.71 3.41a8.13 8.13 0 0 0 4.59 0s1.8 2.15 3.63 1.8z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "m311 205.19a33.58 33.58 0 0 0 10-7.92",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "m315.33 208.49a32.84 32.84 0 0 0 10.48-8.05",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "m321.63 211.93s5.76-4.31 8.5-7.87",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M357.65,169.44c.21-.76.37-1.52.51-2.27-8.38-5.59-18.94-3.76-24.57-2.13.18.87.3,1.38.3,1.38l-.87,1.4C346.48,164.57,353.9,167,357.65,169.44Z",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M351.81,174.55a10.18,10.18,0,0,0,2.62,2.18c.41-.71.8-1.39,1.15-2a28.72,28.72,0,0,0,2.92-16.28,9.54,9.54,0,0,0-5.77,2.27A9.84,9.84,0,0,0,351.81,174.55Z",
  fill: "#91C788",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "m257.06 138.09s4.16 12 9.51 12.89 12.79-8.19 14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07 20-23.07 20-8.61-7.57-13.18-3.66 1.39 15.87 5.6 20.8 11.89 12.16 19.26 10.44 13.21-15.55 18-19.62 8-2.32 9.06-1.09z",
  fill: "#fff"
});

var _ref56 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M269,141c-8.13-3.9-5.85-13.66-14-16.26s-7.48,2.93-14,13.34-18.54,9.75-26.67,7.15a79.89,79.89,0,0,1-7.59-2.89,34.21,34.21,0,0,0,4,6.11c4.21,4.93,11.86,12.09,19.22,10.37s13.21-15.55,18-19.62,8.06-2.32,9.11-1.09c0,0,4.16,12,9.51,12.89s12.79-8.19,14.3-15a10.36,10.36,0,0,0,.19-3.4l-.38-.08S277.1,144.89,269,141Z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269,141c-8.13-3.9-5.85-13.66-14-16.26s-7.48,2.93-14,13.34-18.54,9.75-26.67,7.15a79.89,79.89,0,0,1-7.59-2.89,34.21,34.21,0,0,0,4,6.11c4.21,4.93,11.86,12.09,19.22,10.37s13.21-15.55,18-19.62,8.06-2.32,9.11-1.09c0,0,4.16,12,9.51,12.89s12.79-8.19,14.3-15a10.36,10.36,0,0,0,.19-3.4l-.38-.08S277.1,144.89,269,141Z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "m257.06 138.09s4.16 12 9.51 12.89 12.79-8.19 14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07 20-23.07 20-8.61-7.57-13.18-3.66 1.39 15.87 5.6 20.8 11.89 12.16 19.26 10.44 13.21-15.55 18-19.62 8-2.32 9.06-1.09z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "m230.83 119.18c-6.64 5.82-12.48 12.11-12.48 12.11s-8.61-7.57-13.18-3.66 1.39 15.87 5.6 20.8 11.86 12.09 19.23 10.37c6.64-1.55 12-13 16.52-18.15a88.79 88.79 0 0 1-15.69-21.47z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "m253 109a22.56 22.56 0 0 0-2.46-0.15 69.54 69.54 0 0 1 1.64 28 5.6 5.6 0 0 1 2.45-0.1c0.55-7.09 0.96-18.84-1.63-27.75z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "m258.61 124.58a8.79 8.79 0 1 1 1-12.4 8.79 8.79 0 0 1-1 12.4z",
  fill: "#91C788",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M230,158.8a11,11,0,0,0,4.66-2.68c-4.71.78-13.41.52-21.32-9-7.7-9.24-7.83-16.43-7.07-20.21a4.87,4.87,0,0,0-1.09.69c-4.58,3.91,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8Z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "m281.13 180.59s12.17 3.58 16-0.24 4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66 8.93-20.83 19.49 2.9 30.42 2.9 30.42-11.15 2.61-10.63 8.61 13.73 8.09 20.18 7.52 16.74-2.63 19.61-9.62-5-19.78-5.54-26 2.82-7.93 4.43-8.07z",
  fill: "#fff"
});

var _ref63 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m281.13 180.59s12.17 3.58 16-0.24c2.5-2.49 3.59-8.26 1.78-13.35s1 5.21-6.18 6.51-18.86-1.3-24.06 5.2 2.27 19.84 2.92 28.62-1.32 11.67-10.1 12.67-16.63-5.3-18.44-1.48c2.69 4.63 13.83 6.25 19.6 5.74 6.46-0.57 16.74-2.63 19.61-9.62s-5-19.78-5.54-26 2.8-7.91 4.41-8.05z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.13 180.59s12.17 3.58 16-0.24c2.5-2.49 3.59-8.26 1.78-13.35s1 5.21-6.18 6.51-18.86-1.3-24.06 5.2 2.27 19.84 2.92 28.62-1.32 11.67-10.1 12.67-16.63-5.3-18.44-1.48c2.69 4.63 13.83 6.25 19.6 5.74 6.46-0.57 16.74-2.63 19.61-9.62s-5-19.78-5.54-26 2.8-7.91 4.41-8.05z",
  fill: "#fff",
  opacity: 0.5
}));

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "m281.13 180.59s12.17 3.58 16-0.24 4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66 8.93-20.83 19.49 2.9 30.42 2.9 30.42-11.15 2.61-10.63 8.61 13.73 8.09 20.18 7.52 16.74-2.63 19.61-9.62-5-19.78-5.54-26 2.82-7.93 4.43-8.07z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M250.5,191c.88,8.79,2.6,17.19,2.6,17.19s-11.15,2.61-10.63,8.61,13.73,8.09,20.18,7.52,16.74-2.63,19.61-9.62c2.59-6.31-3.54-17.32-5.18-24A88.55,88.55,0,0,1,250.5,191Z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "m255.08 167.06a21.79 21.79 0 0 0-1.54 1.91 69.88 69.88 0 0 1 23.71 14.91 5.57 5.57 0 0 1 1.34-2c-5.41-4.65-14.74-11.81-23.51-14.82z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref67 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-39.6 86.65) rotate(-17.46)",
  cx: 262.27,
  cy: 172.25,
  r: 8.8,
  fill: "#91C788",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "m282.26 214.66a10.89 10.89 0 0 0 0.52-5.35c-2.1 4.29-7.36 11.22-19.68 12.14-12 0.9-17.93-3.17-20.55-6a4.58 4.58 0 0 0-0.08 1.29c0.53 6 13.73 8.09 20.18 7.52s16.74-2.61 19.61-9.6z",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "m350.87 92.66a93.78 93.78 0 0 1-7.17-10.92 22.59 22.59 0 1 0 19.51 24.26 91.3 91.3 0 0 1-12.34-13.34z",
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.1915px"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "m353.06 113.17a7.26 7.26 0 1 1 0.45-9.91 7 7 0 0 1-0.45 9.91z",
  fill: "#fff"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "m345.63 96.42a2.16 2.16 0 1 1 0.23-3 2.15 2.15 0 0 1-0.23 3z",
  fill: "#fff"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  transform: "translate(27.38 -11.26) rotate(5.62)",
  x: 125.16,
  y: 268.54,
  width: 6.45,
  height: 9.32,
  fill: "#263238"
});

function Svg404Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "30 30 500 500",
    width: 350,
    height: 350,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404-error.38b35835.svg";
export { ForwardRef as ReactComponent };